// 🔒 Globaler Scroll-Lock gegen Theme-Autoscrolling
const EldrScrollLock = {
  active: false,
  y: 0,
  timeoutId: null,

  lock(ms = 400) {
    this.y = window.scrollY || window.pageYOffset || 0;
    this.active = true;
    if (this.timeoutId) clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.active = false;
    }, ms);
  },

  handleScroll() {
    if (!this.active) return;
    window.scrollTo(0, this.y);
  }
};

// Globaler Listener – nur wenn Lock aktiv
window.addEventListener('scroll', () => {
  EldrScrollLock.handleScroll();
}, { passive: true });

// 🚫 Erst prüfen, ob es sich um eine Produktseite handelt
function initEldrSticky() {
  const path = window.location.pathname;

  const productForm =
    document.querySelector('form.shopify-product-form[data-type="add-to-cart-form"]') ||
    document.querySelector('form[action*="/cart/add"]');

  const isProductLike =
    path.includes('/products/') ||
    path.includes('/products_preview') ||
    !!productForm ||
    !!document.querySelector('input[name="id"]');

  if (!isProductLike) {
    console.log("🧩 Stickybar deaktiviert – keine Produktseite erkannt.");
    return;
  }

  if (!productForm) {
    console.log("⚠️ Kein Produktformular gefunden – Stickybar übersprungen.");
    return;
  }

  console.log("🪄 ELDR Stickybar aktiviert");
  runEldrSticky();
}

// === Hauptfunktion ===
function runEldrSticky() {
  const productForm = document.querySelector('form.shopify-product-form[data-type="add-to-cart-form"]');
  if (!productForm) return;

  const existingBar = document.querySelector('.eldr-sticky-bar');
  if (existingBar) existingBar.remove();

  // === Stickybar Grundstruktur mit ARIA ===
  const stickyBar = document.createElement('div');
  stickyBar.classList.add('eldr-sticky-bar');
  stickyBar.setAttribute('role', 'region');
  stickyBar.setAttribute('aria-label', 'Sticky Produktleiste');
  stickyBar.innerHTML = `
    <div class="eldr-sticky-inner">
      <div class="eldr-sticky-left">
        <img class="eldr-sticky-img" src="" alt="Produktbild" loading="lazy">
        <div class="eldr-sticky-info">
          <div class="eldr-sticky-title"></div>
          <div class="eldr-sticky-price" aria-live="polite"></div>
        </div>
      </div>
      <div class="eldr-sticky-right">
        <select class="eldr-sticky-variant-select" style="display:none;" aria-label="Variante auswählen"></select>
        <div class="eldr-sticky-qty-wrapper">
          <button type="button" class="eldr-sticky-minus" aria-label="Menge verringern">−</button>
          <input type="number" name="quantity" value="1" min="1" class="eldr-sticky-qty-input" aria-label="Menge">
          <button type="button" class="eldr-sticky-plus" aria-label="Menge erhöhen">+</button>
        </div>
        <button class="eldr-sticky-add" aria-live="polite">In den Warenkorb</button>
      </div>
      <div class="eldr-sticky-notification" role="alert" aria-live="assertive" style="display:none;"></div>
    </div>`;
  document.body.appendChild(stickyBar);

  // === Referenzen ===
  const stickyImg = stickyBar.querySelector('.eldr-sticky-img');
  const stickyTitle = stickyBar.querySelector('.eldr-sticky-title');
  const stickyPrice = stickyBar.querySelector('.eldr-sticky-price');
  const variantSelect = stickyBar.querySelector('.eldr-sticky-variant-select');
  const qtyInput = stickyBar.querySelector('.eldr-sticky-qty-input');
  const addBtn = stickyBar.querySelector('.eldr-sticky-add');
  const notification = stickyBar.querySelector('.eldr-sticky-notification');
  
  const paymentWrapper =
    document.querySelector('.product-form-block[data-block-id="buy_buttons"]') ||
    document.querySelector('.shopify-payment-button') ||
    document.querySelector('.product-form__buttons') ||
    document.querySelector('[name="add"]');

  // === Notification Helper ===
  function showNotification(message, type = 'info') {
    notification.textContent = message;
    notification.className = `eldr-sticky-notification eldr-sticky-notification--${type}`;
    notification.style.display = 'block';
    
    setTimeout(() => {
      notification.style.display = 'none';
    }, 3000);
  }

  // === Mengensteuerung (+ / -) mit Event Delegation ===
  const qtyHandler = (e) => {
    const wrap = e.target.closest(".eldr-sticky-qty-wrapper");
    if (!wrap) return;
    
    const input = wrap.querySelector("input");
    let value = parseInt(input.value, 10) || 1;

    if (e.target.classList.contains("eldr-sticky-minus")) {
      e.preventDefault();
      input.value = Math.max(1, value - 1);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (e.target.classList.contains("eldr-sticky-plus")) {
      e.preventDefault();
      input.value = value + 1;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };
  
  stickyBar.addEventListener("click", qtyHandler);

  // === Produktinfos aktualisieren ===
  function updateStickyInfo() {
    const img = document.querySelector(
      '.theme-img.media-ratio--tall, .product__media img, .product__media-list img, .product-gallery img'
    );
    const title =
      document.querySelector('[data-update-id="item-title"] h1') ||
      document.querySelector('h1.h2.product-details__product-title') ||
      document.querySelector('.product__title, [data-product-title]');
    const price = document.querySelector(
      '[data-update-id="item-price"] .money, [data-product-price].money, .product__price .money, .price .money'
    );

    if (img && img.src) {
      stickyImg.src = img.src;
      stickyImg.alt = title?.textContent?.trim() || 'Produktbild';
    }
    if (title && title.textContent) {
      stickyTitle.textContent = title.textContent.trim();
    }
    if (price && price.textContent) {
      stickyPrice.textContent = price.textContent.trim();
    }
    // NEU: Button-Status synchronisieren
  syncButtonState(); updateVariantAvailabilityUI();

  }

  // === Button-Status synchronisieren ===
function syncButtonState() {
  // Finde den Original Add-to-Cart Button
  const originalButton = productForm.querySelector('button[type="submit"]') ||
                        productForm.querySelector('button[name="add"]') ||
                        document.querySelector('button[id*="ProductSubmitButton"]');
  
  if (!originalButton) return;
  
  // Synchronisiere disabled State
  const isDisabled = originalButton.disabled || originalButton.hasAttribute('disabled');
  addBtn.disabled = isDisabled;
  
  // Synchronisiere Text
  const unavailableText = originalButton.querySelector('[data-unavailable-text]')?.textContent ||
                         originalButton.querySelector('[data-add-to-cart-text]')?.dataset.unavailableText ||
                         'Ausverkauft';
  
  const availableText = originalButton.querySelector('[data-add-to-cart-text]')?.textContent ||
                       'In den Warenkorb';
  
  if (isDisabled) {
    addBtn.textContent = unavailableText;
    addBtn.classList.add('disabled');
  } else {
    addBtn.textContent = availableText;
    addBtn.classList.remove('disabled');
  }
  
  console.log('🔄 Button State synced:', { disabled: isDisabled, text: addBtn.textContent });
}

    // --- Helper: Strike-Through für Option-Text (funktioniert auch in <option>)
    const STRIKE = "\u0336";
    function strikeText(text = "") {
      return text.split("").map(ch => ch + STRIKE).join("");
    }

    function isVariantAvailable(wrapper, inputEl) {
      const attr = wrapper.getAttribute("data-swatch-option-available");
      const byAttr = (attr === null) ? true : (attr === "true");
      const byInput = inputEl ? !inputEl.disabled : true;
      return byAttr && byInput;
    }

    function updateVariantAvailabilityUI() {
      const opt = variantSelect.options[variantSelect.selectedIndex];
      const available = opt?.dataset?.available !== "false";
      variantSelect.classList.toggle("eldr-variant-soldout", !available);
    }

  // === Variantenliste füllen ===
  function populateVariants() {
  // ALT war: nur available=true -> dadurch verschwinden Sold-Out Varianten
  // const variants = document.querySelectorAll('[data-swatch-option-available="true"][data-swatch-variant-id]');

  const wrappers = document.querySelectorAll('[data-swatch-variant-id]');
  variantSelect.innerHTML = '';

  if (wrappers.length === 0) {
    variantSelect.style.display = 'none';
    stickyBar.classList.remove('has-variants');
    const qtyWrapper = stickyBar.querySelector('.eldr-sticky-qty-wrapper');
    if (qtyWrapper) qtyWrapper.style.display = 'inline-flex';
    return;
  }

  stickyBar.classList.add('has-variants');
  const qtyWrapper = stickyBar.querySelector('.eldr-sticky-qty-wrapper');
  if (qtyWrapper) qtyWrapper.style.display = 'none';
  variantSelect.style.display = 'block';

  wrappers.forEach(w => {
    const id = w.dataset.swatchVariantId;
    if (!id) return;

    const input = w.querySelector('input[type="radio"][data-product-variant], input[type="radio"]');
    const labelRaw = (w.dataset.value || w.textContent || '').trim();

    const available = isVariantAvailable(w, input);

    const opt = document.createElement('option');
    opt.value = id;
    opt.dataset.available = available ? "true" : "false";

    // Durchgestrichen + Zusatz (Ausverkauft)
    if (!available) opt.classList.add('is-soldout');

    opt.textContent = available
    ? labelRaw
    : `${labelRaw} — AUSVERKAUFT!`;

    if (input && input.checked) opt.selected = true;
    variantSelect.appendChild(opt);
});
  // Fallback: falls nix selected ist
  if (!variantSelect.value && variantSelect.options.length) {
    variantSelect.selectedIndex = 0;
  }

  updateVariantAvailabilityUI();
}


 // === Variant Select Handler ===
const variantChangeHandler = () => {
  const id = variantSelect.value;
  const radio = document.querySelector(`[data-swatch-variant-id="${id}"] input[type="radio"]`);
  if (!radio || radio.checked) return;

  // Speichere Position VOR dem Change
  const scrollY = window.scrollY;
  
  // Kurzer Lock nur während des Events
setTimeout(() => EldrScrollLock.lock(200), 0);

  radio.checked = true;
  radio.dispatchEvent(new Event('change', { bubbles: true }));

  // Warte kurz, dann stelle Position wieder her (nur 1x)
  setTimeout(() => {
    window.scrollTo({ top: scrollY, behavior: 'instant' });
    updateStickyInfo(); updateVariantAvailabilityUI();
  }, 50);
  
};

  
  variantSelect.addEventListener('change', variantChangeHandler);

  // === Original → Sticky Sync ===
  const radioChangeHandlers = new WeakMap(); // Verhindert Memory Leaks
  
  function bindRadioListeners() {
    const radios = document.querySelectorAll('[data-swatch-variant-id] input[type="radio"]');
    
    radios.forEach(radio => {
      // Entferne alten Handler falls vorhanden
      const oldHandler = radioChangeHandlers.get(radio);
      if (oldHandler) {
        radio.removeEventListener('change', oldHandler);
      }
      
      // Erstelle neuen Handler
     const handler = (e) => {
  const wrapper = e.target.closest('[data-swatch-variant-id]');
  if (!wrapper) return;
  const id = wrapper.dataset.swatchVariantId;
  if (variantSelect.value !== id) {
    variantSelect.value = id;
    updateStickyInfo();
  }
};
      
      radioChangeHandlers.set(radio, handler);
      radio.addEventListener('change', handler);
    });
  }

  // === Add to Cart über das native Flow-Produktformular ===
  const addToCartHandler = () => {
    const variantId = variantSelect.value || productForm.querySelector('input[name="id"]')?.value;
    const qty = Math.max(1, parseInt(qtyInput.value || '1', 10));

    if (!variantId) {
      showNotification('Bitte wähle eine Variante aus', 'error');
      return;
    }

    // Sticky-Auswahl an das originale Produktformular übergeben.
    const originalVariantInput = productForm.querySelector('input[name="id"]');
    if (originalVariantInput) {
      originalVariantInput.value = variantId;
      originalVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    let originalQtyInput = productForm.querySelector('input[name="quantity"]');
    if (!originalQtyInput) {
      originalQtyInput = document.createElement('input');
      originalQtyInput.type = 'hidden';
      originalQtyInput.name = 'quantity';
      productForm.appendChild(originalQtyInput);
    }
    originalQtyInput.value = qty;
    originalQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    originalQtyInput.dispatchEvent(new Event('change', { bubbles: true }));

    const originalAddButton =
      productForm.querySelector('button[name="add"]') ||
      productForm.querySelector('button[type="submit"]');

    if (!originalAddButton || originalAddButton.disabled) {
      showNotification('Produkt ist nicht verfügbar oder ausverkauft', 'error');
      return;
    }

    // Flow übernimmt Cart-Request, Drawer-Rendering, Zähler und Fehlerbehandlung.
    productForm.requestSubmit(originalAddButton);
  };

  addBtn.addEventListener('click', addToCartHandler);

// === Optimierte Sticky Sichtbarkeit (korrekte Logik v2) ===
let ticking = false;

function toggleSticky() {
  if (ticking) return;
  
  ticking = true;
  requestAnimationFrame(() => {
    // DEIN THEME: Suche nach den richtigen Selektoren
    const ref = 
      document.querySelector('.paymentButtonsWrapper') || // Dein Haupt-Container
      document.querySelector('button[id*="ProductSubmitButton"]') || // Dein Add-Button
      document.querySelector('.shopify-payment-button') || // PayPal
      document.querySelector('button[name="add"]') || // Fallback
      productForm; // Letzter Fallback
    
    if (!ref) {
      console.warn('⚠️ Keine Referenz für Sticky-Toggle gefunden');
      ticking = false;
      return;
    }
    
    const rect = ref.getBoundingClientRect();
    const buffer = 175; // Anpassbar
    
    // NEUE LOGIK:
    // Sticky VERSTECKT nur wenn Button im Viewport ist
    // Sticky SICHTBAR wenn Button ÜBER oder UNTER dem Viewport ist
    const isButtonInViewport = 
      rect.top < (window.innerHeight - buffer) && // Button ist nicht zu weit unten
      rect.bottom > buffer; // Button ist nicht zu weit oben
    
    // Sticky verstecken NUR wenn Button sichtbar ist
    stickyBar.classList.toggle('visible', !isButtonInViewport);
    
    // Debug
    if (window.eldrStickyDebug) {
      console.log('Sticky Check:', {
        element: ref.className || ref.id,
        top: rect.top,
        bottom: rect.bottom,
        windowHeight: window.innerHeight,
        buffer: buffer,
        buttonInViewport: isButtonInViewport,
        stickyVisible: !isButtonInViewport
      });
    }
    
    ticking = false;
  });
}


  // Throttled Scroll/Resize
  let scrollThrottle, resizeThrottle;
  
  window.addEventListener('scroll', () => {
    if (!scrollThrottle) {
      scrollThrottle = setTimeout(() => {
        toggleSticky();
        scrollThrottle = null;
      }, 100);
    }
  }, { passive: true });

  window.addEventListener('resize', () => {
    if (!resizeThrottle) {
      resizeThrottle = setTimeout(() => {
        toggleSticky();
        resizeThrottle = null;
      }, 150);
    }
  }, { passive: true });

  // === Shopify variant:change Event ===
  const variantChangeListener = () => {
    requestAnimationFrame(updateStickyInfo);
  };
  document.addEventListener('variant:change', variantChangeListener);

  // === Optimierter MutationObserver mit Debouncing ===
  const parentContainer =
    document.querySelector('.product-details--form-wrapper') ||
    document.querySelector('.product-single') ||
    document.querySelector('main');

  let mutationTimeout;
  let observer;

  if (parentContainer) {
    observer = new MutationObserver((mutations) => {
      // Nur relevante Mutations beachten
      const hasRelevantChange = mutations.some(m => 
        Array.from(m.addedNodes).some(node => 
          node.nodeType === 1 && 
          (node.matches?.('product-swatch') || node.querySelector?.('product-swatch'))
        )
      );

      if (!hasRelevantChange) return;

      // Debounce
      if (mutationTimeout) clearTimeout(mutationTimeout);
      
      mutationTimeout = setTimeout(() => {
        console.log('♻️ Neues <product-swatch> erkannt → Reinit');
        populateVariants();
        bindRadioListeners();
        updateStickyInfo();
      }, 300);
    });

    // Nur childList beobachten, nicht subtree (Performance!)
    observer.observe(parentContainer, { 
      childList: true, 
      subtree: true 
    });
  }


// === Beobachte Original-Button für disabled-Änderungen ===
const originalButton = productForm.querySelector('button[type="submit"]') ||
                      productForm.querySelector('button[name="add"]') ||
                      document.querySelector('button[id*="ProductSubmitButton"]');

if (originalButton) {
  const buttonObserver = new MutationObserver(() => {
    syncButtonState();
  });
  
  buttonObserver.observe(originalButton, {
    attributes: true,
    attributeFilter: ['disabled', 'class']
  });
  
  // Cleanup erweitern
  const originalCleanup = window.eldrStickyCleanup;
  window.eldrStickyCleanup = () => {
    if (buttonObserver) buttonObserver.disconnect();
    if (originalCleanup) originalCleanup();
  };
}



  // === Cleanup Funktion für Event Listeners ===
  window.eldrStickyCleanup = () => {
    stickyBar.removeEventListener("click", qtyHandler);
    variantSelect.removeEventListener('change', variantChangeHandler);
    addBtn.removeEventListener('click', addToCartHandler);
    document.removeEventListener('variant:change', variantChangeListener);
    if (observer) observer.disconnect();
    if (mutationTimeout) clearTimeout(mutationTimeout);
    if (scrollThrottle) clearTimeout(scrollThrottle);
    if (resizeThrottle) clearTimeout(resizeThrottle);
    stickyBar.remove();
  };

  // === Init ===
  populateVariants();
  bindRadioListeners();
  updateStickyInfo();
  toggleSticky();

  console.log('✅ Stickybar läuft OPTIMIERT (v2.0 - Performance + Error Handling + A11y)');
}

// === Safe Load + ReInit bei AJAX-Navigation ===
function safeInitStickybar() {
  // Cleanup vorherige Instanz
  if (window.eldrStickyCleanup) {
    window.eldrStickyCleanup();
  }
  
  const existing = document.querySelector('.eldr-sticky-bar');
  if (existing) existing.remove();
  
  initEldrSticky();
}

// 1️⃣ Initial beim Laden
if (document.readyState === 'complete') {
  safeInitStickybar();
} else {
  window.addEventListener('load', safeInitStickybar);
}

// 2️⃣ Shopify Section Events
const shopifyEvents = [
  'shopify:section:load',
  'shopify:page:load',
  'shopify:section:select',
  'shopify:section:deselect'
];

shopifyEvents.forEach(event => {
  document.addEventListener(event, safeInitStickybar);
});
